import { render, staticRenderFns } from "./StatisticCards.vue?vue&type=template&id=92aa4646&"
import script from "./StatisticCards.vue?vue&type=script&lang=js&"
export * from "./StatisticCards.vue?vue&type=script&lang=js&"
import style0 from "./StatisticCards.vue?vue&type=style&index=0&id=92aa4646&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports